import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { api } from "../apis/config/axiosConfig";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_AI_MBR;

// Async thunk to fetch data
export const fetchAiMbrdData = createAsyncThunk(
    "mbr/data",
    async (_, { getState, rejectWithValue }) => {
      const state = getState();
      if (state.aiMbr.data) {
        return rejectWithValue("Data already fetched");
      }
      try {
        setBaseURL(api, DEV_BASE_URL);
        const response = await api.get("/mbr/data");
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || "Something went wrong");
      }
    }
  );

  const aiMbrSlice = createSlice({
    name: "mbr-data",
    initialState: {
      data: null,
      loading: false,
      error: null,
      sidebarData: {
        activeWindow: 'graphical',
        selectedYear: 'All',
        Complaint: true,
        ER: true
      },
    },
    reducers: {
      toggleWindow: (state, action) => {
        state.sidebarData.activeWindow = action.payload
      },
      changeDateRange: (state, action) => {
        state.sidebarData.selectedYear = action.payload;
      },
      changeAIMBRComSelection: (state, action) => {
        state.sidebarData.Complaint = action.payload
      },
      changeAIMBRErSelection: (state, action) => {
        state.sidebarData.ER = action.payload
      }
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchAiMbrdData.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(fetchAiMbrdData.fulfilled, (state, action) => {
          state.loading = false;
          state.data = action.payload;
        })
        .addCase(fetchAiMbrdData.rejected, (state, action) => {
          state.loading = false;
          if (action.payload !== "Data already fetched") {
            state.error = action.payload;
          }
        });
    },
  });
  
  export const { toggleWindow, changeDateRange, changeAIMBRComSelection, changeAIMBRErSelection } = aiMbrSlice.actions;

  export default aiMbrSlice.reducer;
  